/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { skillsListSuggestionFeedback } from "../funcs/skillsListSuggestionFeedback.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListSkillSuggestionFeedbackResult } from "../models/components/listskillsuggestionfeedbackresult.js";
import {
  ListSkillSuggestionFeedbackRequest,
  ListSkillSuggestionFeedbackSecurity,
} from "../models/operations/listskillsuggestionfeedback.js";
import { unwrapAsync } from "../types/fp.js";
export type SkillSuggestionFeedbackQueryData =
  ListSkillSuggestionFeedbackResult;

export function prefetchSkillSuggestionFeedback(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListSkillSuggestionFeedbackRequest,
  security?: ListSkillSuggestionFeedbackSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSkillSuggestionFeedbackQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSkillSuggestionFeedbackQuery(
  client$: GramCore,
  request: ListSkillSuggestionFeedbackRequest,
  security?: ListSkillSuggestionFeedbackSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<SkillSuggestionFeedbackQueryData>;
} {
  return {
    queryKey: queryKeySkillSuggestionFeedback({
      id: request.id,
      limit: request.limit,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function skillSuggestionFeedbackQueryFn(
      ctx,
    ): Promise<SkillSuggestionFeedbackQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(skillsListSuggestionFeedback(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySkillSuggestionFeedback(
  parameters: {
    id: string;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "listSuggestionFeedback", parameters];
}
